import AdminDashboard from '../../views/AdminDashboard';
import { useQuery } from '@tanstack/react-query';
import { useSearchParams } from 'react-router';
import { useApiClients } from '../../client/api/useApiClient';
import { GetOrganizationsResponse } from '@EHSNavigator/backend';

export default function AdminDashboardPage() {
  const { AdminApi } = useApiClients();
  const [searchParams] = useSearchParams();
  const searchQuery = searchParams.get('search') ?? '';
  const currentPage = Number(searchParams.get('page')) || 1;
  const limit = Number(searchParams.get('limit')) || 10;

  const {
    data: organizationsData,
    isLoading,
    isRefetching,
  } = useQuery<GetOrganizationsResponse, Error>({
    queryKey: [
      'get-admin-organizations',
      searchQuery,
      Number(currentPage),
      Number(limit),
    ],
    queryFn: async () => {
      const response =
        await AdminApi.adminControllerGetOrganizations({
          page: Number(currentPage) || 1,
          limit: Number(limit),
          status: undefined,
          search: searchQuery || undefined,
        });

      return response?.data;
    },
  });

  const hasFilters = !!searchQuery;

  const noDataMessage = hasFilters
    ? 'No items match your filters or search. Try using different keywords maybe.'
    : 'No organizations found';
console.log({organizationsData});

  return (
    <div className="flex w-full flex-1 flex-col px-15 pt-14 pb-10 md:px-25 lg:pr-14 lg:pb-20 lg:pl-8">
      <AdminDashboard
        data={organizationsData}
        noDataMessage={noDataMessage}
        params={{
          search: searchQuery,
          page: Number(currentPage),
          limit: Number(limit),
        }}
        isOrganizationsLoading={isLoading || isRefetching}
      />
    </div>
  );
}

